(function () {
  'use strict';

  // ── Locale prefix from current URL ──────────────────────────────────────────
  // Matches /es-eu/, /nl-eu/, /en-pl/, /de-eu/, /sv-se/, /ar-ae/, etc.
  function getLocalePrefix() {
    var m = window.location.pathname.match(/^\/([a-z]{2}-[a-z]{2}|[a-z]{2})\//i);
    return m ? '/' + m[1].toLowerCase() : '';
  }

  // ── Price formatting ─────────────────────────────────────────────────────────
  // /products.json (default locale) returns prices in the shop's base currency.
  // Apply Shopify.currency.rate to convert to the active locale currency.
  function formatPrice(priceStr) {
    var base     = parseFloat(priceStr);
    var rate     = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
    var amount   = base * rate;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var locale   = (window.Shopify && window.Shopify.locale) || 'en';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency', currency: currency, minimumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return currency + ' ' + amount.toFixed(2);
    }
  }

  // ── Build single product card ────────────────────────────────────────────────
  function buildCard(product, localePrefix, shopNow) {
    var img     = product.images && product.images[0] ? product.images[0].src : '';
    var imgSrc  = img ? img.replace(/(\.[^.?]+)(\?.*)?$/, '_400x$1') : '';
    var variant = product.variants && product.variants[0];
    var price   = variant ? formatPrice(variant.price) : '';
    var compare = variant && variant.compare_at_price
                  && parseFloat(variant.compare_at_price) > parseFloat(variant.price)
                  ? formatPrice(variant.compare_at_price) : '';
    var url     = localePrefix + '/products/' + product.handle;
    var title   = product.title
                    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
    var vendor  = product.vendor
                  ? '<p class="ocg-pc__vendor">' +
                    product.vendor.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</p>'
                  : '';

    return '<div class="ocg-pc">'
      + '<a href="' + url + '" class="ocg-pc__img-link" tabindex="-1" aria-hidden="true">'
      +   '<div class="ocg-pc__img-wrap">'
      +     (imgSrc
              ? '<img src="' + imgSrc + '" alt="' + title + '" loading="lazy" width="400" height="400">'
              : '<div class="ocg-pc__img-placeholder"></div>')
      +   '</div>'
      + '</a>'
      + '<div class="ocg-pc__body">'
      +   vendor
      +   '<p class="ocg-pc__title"><a href="' + url + '">' + title + '</a></p>'
      +   '<div class="ocg-pc__price-row">'
      +     '<span class="ocg-pc__price">' + price + '</span>'
      +     (compare ? '<s class="ocg-pc__compare">' + compare + '</s>' : '')
      +   '</div>'
      +   '<a href="' + url + '" class="ocg-pc__btn">' + shopNow + '</a>'
      + '</div>'
      + '</div>';
  }

  // ── Drag-to-scroll ────────────────────────────────────────────────────────────
  function initDrag(track) {
    if (!track) return;
    var isDown = false, startX, scrollLeft;
    track.addEventListener('mousedown', function (e) {
      isDown     = true;
      startX     = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    track.addEventListener('mouseleave', function () { isDown = false; track.classList.remove('is-dragging'); });
    track.addEventListener('mouseup',    function () { isDown = false; track.classList.remove('is-dragging'); });
    track.addEventListener('mousemove',  function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      track.scrollLeft = scrollLeft - (x - startX) * 1.2;
    });
  }

  // ── Process one placeholder slot ─────────────────────────────────────────────
  function processSlot(slot) {
    var handle  = slot.getAttribute('data-handle');
    var eyebrow = slot.getAttribute('data-eyebrow') || 'You might also like';
    var viewAll = slot.getAttribute('data-view-all') || 'View all';
    var shopNow = slot.getAttribute('data-shop-now') || 'Shop Now';

    if (!handle) return;

    var localePrefix = getLocalePrefix();
    var qs           = '/products.json?limit=5&sort_by=best-selling';
    var urlLocale    = (localePrefix ? localePrefix : '') + '/collections/' + handle + qs;
    var urlDefault   = '/collections/' + handle + qs;

    fetch(urlLocale)
      .then(function (res) { return res.ok ? res.json() : Promise.reject(res.status); })
      .then(function (data) {
        var products = data.products || [];
        if (products.length < 2) return fetch(urlDefault).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); });
        return data;
      })
      .then(function (data) {
        if (!data) return;
        var products = data.products || [];
        if (products.length < 2) return;

        var localePrefix = getLocalePrefix();
        var colUrl       = localePrefix + '/collections/' + handle;

        var cards = products.slice(0, 5).map(function (p) {
          return buildCard(p, localePrefix, shopNow);
        }).join('');

        var wrap = document.createElement('div');
        wrap.innerHTML =
          '<div class="ocg-carousel" data-handle="' + handle + '">'
          + '<div class="ocg-carousel__head">'
          +   '<span class="ocg-carousel__eyebrow">' + eyebrow + '</span>'
          +   '<a href="' + colUrl + '" class="ocg-carousel__view-all">' + viewAll + ' &rarr;</a>'
          + '</div>'
          + '<div class="ocg-carousel__track">' + cards + '</div>'
          + '</div>';

        var carousel = wrap.firstElementChild;
        slot.parentNode.replaceChild(carousel, slot);
        initDrag(carousel.querySelector('.ocg-carousel__track'));
      })
      .catch(function () {});
  }

  // ── Boot ─────────────────────────────────────────────────────────────────────
  function init() {
    var slots = document.querySelectorAll('.ocg-carousel-slot[data-handle]');
    slots.forEach(processSlot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
